// extracted by mini-css-extract-plugin
export default {"form":"ATtw9G"};